import React from 'react'
import Grid from '@mui/material/Grid'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'

const VehiclesInvolved = ({ formValues, handleChange, vehicleOptions }) => {
  return (
    <Grid item xs={12}>
      <Autocomplete
        fullWidth
        multiple
        options={vehicleOptions}
        onChange={(e, value) =>
          handleChange({
            moduleName: 'incident',
            field: 'incidentVehicles',
            value,
          })
        }
        value={formValues?.incident?.incidentVehicles ?? []}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        getOptionLabel={(opt) => opt?.callSign}
        disabled={vehicleOptions.length === 0}
        renderInput={(params) => (
          <TextField {...params} label="Vehicles Involved in Patient Care" />
        )}
      />
    </Grid>
  )
}

export default VehiclesInvolved
